<template>
  <div
    style="height:130px;padding:2em;text-align:center; cursor:pointer;"
    @click="parameters()"
  >
    <img
      style="width:50px;"
      src="@/assets/img/icons/create.png"
      alt="create-icon"
    />
    <p class="color-primary">{{ $t("button.ajouter_event") }}</p>
  </div>
</template>
<script>
export default {
  methods: {
    parameters(evt) {
      this.$store.commit("CLEAR_FIELDS");
      this.$store.dispatch("popupToggle");
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        cardList: false,
        parameters: true
      });
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/event/components/AddEvenementButton.vue